<template>
  <div class="itemCard" :style="gridHeight" @click="selectItem">
    <div v-if="item.type === ItemType.Video" class="video-wrapper">
      <img class="playbutton" src="@/assets/icons/icon_play.svg" />
      <img v-bind:src="fileURL" />
    </div>

    <img v-else v-bind:src="fileURL">
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { Item } from '@/dto/Item'
import { randomFileServer } from '@/services/Api'
import { ItemType } from '@/dto/enums/ItemType'
import * as router from '@/router'
import { logDetailClick } from '@/services/EventLogger'

export default defineComponent({
  props: {
    item: {
      type: Item,
      required: true
    },
    useSmallColumns: {
      type: Boolean,
      default: true
    }
  },

  setup() {
    return { ItemType }
  },

  methods: {
    selectItem() {
      logDetailClick()
      router.default.push({ name: router.routeNames.ITEM, params: { id: this.item.id } })
    }
  },

  computed: {
    fileURL(): string {
      const fs = randomFileServer()
      if (fs) {
        // GIF
        if (this.item.type === ItemType.Gif && this.item.animatedThumbUrl) {
          return fs.concat(this.item.animatedThumbUrl)
        }

        // Image or Video
        if ((this.item.type === ItemType.Image || this.item.type === ItemType.Video) && this.item.thumbUrl) {
          return fs.concat(this.item.thumbUrl)
        }

        // Fallback
        if (this.item.type !== ItemType.Video) {
          return fs.concat(this.item.url)
        }

        return ''
      }

      return ''
    },

    gridHeight() {
      const hmargin = 5

      const width = this.useSmallColumns ? 168 : 232
      const rowheight = 10

      const itemRatio: number = this.item.ratio
      const neededHeight = width * itemRatio + (hmargin * 2)
      const neededRows = Math.floor(neededHeight / rowheight)

      return {
        'grid-row-end': 'span ' + neededRows
      }
    }
  }
})
</script>

<style lang="sass" scoped>
.itemCard
  padding: 0
  margin: 5px 5px
  border-radius: 16px
  background-color: $color_surface
  overflow: hidden
  cursor: pointer
  position: relative

.video-wrapper
  height: 100%
  width: 100%

.playbutton
  left:50%
  top:50%
  transform: translate(-50%, -50%)
  width: 35%
  height: auto
  position: absolute
  filter: drop-shadow(0px 0px 5px rgba(0, 0, 0, 0.5))
  opacity: 0.9

img
  width: 100%

video
  width: 100%
</style>
